module.exports = __webpack_public_path__ + "media/slot-game/cal-check-1d268941.svg";